import { render } from "./HistoryModal.vue?vue&type=template&id=3c7c6616&scoped=true"
import script from "./HistoryModal.vue?vue&type=script&lang=js"
export * from "./HistoryModal.vue?vue&type=script&lang=js"

import "./HistoryModal.vue?vue&type=style&index=0&id=3c7c6616&scoped=true&lang=css"

import exportComponent from "/home/PersonaExplorer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7c6616"]])

export default __exports__